import React, { useCallback, useEffect, useState } from 'react';
import { getListVAT } from './helpers/call-api';
import VATFilter from './components/VATFilter';
import VATTable from './components/VATTable';
// components

const VAT = () => {
  const [params, setParams] = useState({
    page: 1,
    itemsPerPage: 25,
    is_active: 1,
  });

  const [dataList, setDataList] = useState({
    items: [],
    itemsPerPage: 0,
    page: 0,
    totalItems: 0,
    totalPages: 0,
  });

  const [loading, setLoading] = useState(true);

  const { items, itemsPerPage, page, totalItems, totalPages } = dataList;

  const getData = useCallback(() => {
    setLoading(true);
    getListVAT(params)
      .then(setDataList)
      .finally(() => {
        setLoading(false);
      });
  }, [params]);
  useEffect(getData, [getData]);

  return (
    <React.Fragment>
      <div className='bw_main_wrapp'>
        <VATFilter
          onChange={(e) => {
            setParams((prev) => {
              return {
                ...prev,
                ...e,
                page: 1,
              };
            });
          }}
        />
        <VATTable
          onChangePage={(page) => {
            setParams((prev) => ({
              ...prev,
              page,
            }));
          }}
          data={items}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          page={page}
          totalItems={totalItems}
          loading={loading}
          onRefresh={getData}
        />
      </div>
    </React.Fragment>
  );
};

export default VAT;
